/** Loopora participant type captured at profile completion (stored in app.user_profiles.role). */
export const PROFILE_PARTICIPANT_ROLES = [
  { value: 'seller', label: 'Data seller — I provide healthcare data' },
  { value: 'buyer', label: 'Data buyer — I purchase or license data' },
  { value: 'both', label: 'Both — I buy and sell data' },
];

export function isProfileParticipantRole(value) {
  return PROFILE_PARTICIPANT_ROLES.some((option) => option.value === value);
}
